import { render, staticRenderFns } from "./TemplateRepair.vue?vue&type=template&id=4dc33648&"
import script from "./TemplateRepair.vue?vue&type=script&lang=ts&"
export * from "./TemplateRepair.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports